export function verificarBaixaAutomatica(listaPagamentos, meioPagamentoList) {
  if (!listaPagamentos.length) return true;
  const meioPagamentoIds = [
    ...new Set(listaPagamentos.map((item) => item.meioPagamentoId)),
  ];
  return meioPagamentoList
    .filter((item) => item.baixaAutomatica)
    .some((item) => meioPagamentoIds.includes(item.id));
}
